import Vue from 'vue'
import router from '../router'
import axios from 'axios'

const host = process.env.VUE_APP_API_SERVER

const routes = {
  login: host + '/api/v1/login',
  logout: host + '/api/v1/logout',
  check: host + '/api/v1/check',
  recovery: host + '/api/v1/recovery',
  reset: host + '/api/v1/reset',
  photos: host + '/api/v1/photos',
  photosActivity: host + '/api/v1/photosActivity',
  nuevaEmpresa: host + '/api/v1/nuevaEmpresa',
  empresas: host + '/api/v1/empresas',
  detalleEmpresa: host + '/api/v1/detalleEmpresa',
  actualizarDetalleEmpresa: host + '/api/v1/actualizarDetalleEmpresa',
  actualizarEmpresaSFTP: host + '/api/v1/actualizarEmpresaSFTP',
  consultaEmpresaSFTP: host + '/api/v1/consultaEmpresaSFTP',
  actualizarEmpresa: host + '/api/v1/actualizarEmpresa',
  eliminarEmpresa: host + '/api/v1/eliminarEmpresa',
  nuevaPlaza: host + '/api/v1/nuevaPlaza',
  plazas: host + '/api/v1/plazas',
  actualizarPlaza: host + '/api/v1/actualizarPlaza',
  eliminarPlaza: host + '/api/v1/eliminarPlaza',
  nuevaSubdireccion: host + '/api/v1/nuevaSubdireccion',
  subdirecciones: host + '/api/v1/subdirecciones',
  actualizarSubdireccion: host + '/api/v1/actualizarSubdireccion',
  eliminarSubdireccion: host + '/api/v1/eliminarSubdireccion',
  nuevaGerencia: host + '/api/v1/nuevaGerencia',
  gerencias: host + '/api/v1/gerencias',
  actualizarGerencia: host + '/api/v1/actualizarGerencia',
  eliminarGerencia: host + '/api/v1/eliminarGerencia',
  nuevaPregunta: host + '/api/v1/nuevaPregunta',
  preguntas: host + '/api/v1/preguntas',
  actualizarPregunta: host + '/api/v1/actualizarPregunta',
  eliminarPregunta: host + '/api/v1/eliminarPregunta',
  nuevaRespuesta: host + '/api/v1/nuevaRespuesta',
  respuestas: host + '/api/v1/respuestas',
  actualizarRespuesta: host + '/api/v1/actualizarRespuesta',
  eliminarRespuesta: host + '/api/v1/eliminarRespuesta',
  nuevoTipoServicio: host + '/api/v1/nuevoTipoServicio',
  tiposServicios: host + '/api/v1/tiposServicios',
  actualizarTipoServicio: host + '/api/v1/actualizarTipoServicio',
  eliminarTipoServicio: host + '/api/v1/eliminarTipoServicio',
  nuevaEncuesta: host + '/api/v1/nuevaEncuesta',
  encuestas: host + '/api/v1/encuestas',
  consultarEncuestasSFTP: host + '/api/v1/consultarEncuestasSFTP',
  actualizarEncuestasSFTP: host + '/api/v1/actualizarEncuestasSFTP',
  actualizarEncuesta: host + '/api/v1/actualizarEncuesta',
  eliminarEncuesta: host + '/api/v1/eliminarEncuesta',
  duplicarEncuesta: host + '/api/v1/duplicarEncuesta',
  actualizarLogicaEncuesta: host + '/api/v1/actualizarLogicaEncuesta',
  nuevoUsuario: host + '/api/v1/nuevoUsuario',
  usuarios: host + '/api/v1/usuarios',
  actualizarUsuario: host + '/api/v1/actualizarUsuario',
  actualizarPassword: host + '/api/v1/actualizarPassword',
  eliminarUsuario: host + '/api/v1/eliminarUsuario',
  actualizarModoDebugUsuario: host + '/api/v1/actualizarModoDebugUsuario',
  dispositivos: host + '/api/v1/dispositivos',
  autorizarDispositivo: host + '/api/v1/autorizarDispositivo',
  denegarDispositivo: host + '/api/v1/denegarDispositivo',
  eliminarDispositivo: host + '/api/v1/eliminarDispositivo',
  nuevaTienda: host + '/api/v1/nuevaTienda',
  tiendas: host + '/api/v1/tiendas',
  totalTiendas: host + '/api/v1/totalTiendas',
  actualizarTienda: host + '/api/v1/actualizarTienda',
  eliminarTienda: host + '/api/v1/eliminarTienda',
  importarTiendas: host + '/api/v1/importarTiendas',
  nuevaRelTiendaEmpresa: host + '/api/v1/nuevaRelTiendaEmpresa',
  relsTiendasEmpresas: host + '/api/v1/relsTiendasEmpresas',
  totalRelsTiendasEmpresas: host + '/api/v1/totalRelsTiendasEmpresas',
  actualizarRelTiendaEmpresa: host + '/api/v1/actualizarRelTiendaEmpresa',
  eliminarRelTiendaEmpresa: host + '/api/v1/eliminarRelTiendaEmpresa',
  importarRelsTiendasEmpresas: host + '/api/v1/importarRelsTiendasEmpresas',
  nuevaActividad: host + '/api/v1/nuevaActividad',
  actividades: host + '/api/v1/actividades',
  totalActividades: host + '/api/v1/totalActividades',
  actualizarActividad: host + '/api/v1/actualizarActividad',
  actualizarFechasActividades: host + '/api/v1/actualizarFechasActividades',
  eliminarActividad: host + '/api/v1/eliminarActividad',
  importarActividades: host + '/api/v1/importarActividades',
  eliminarActividadesPorFecha: host + '/api/v1/eliminarActividadesPorFecha',
  resultados: host + '/api/v1/resultados',
  resultadosHistoricos: host + '/api/v1/resultadosHistoricos',
  resultadosPDF: host + '/api/v1/resultadosPDF',
  detalleResultado: host + '/api/v1/detalleResultado',
  reporteResultado: host + '/api/v1/reporteResultado',
  temporales: host + '/api/v1/temporales',
  imagen: host + '/api/v1/imagen',
  dashboard: host + '/api/v1/dashboard',
  logo: host + '/api/v1/logo',
  actualizarLogo: host + '/api/v1/actualizarLogo',
  tabularEncuesta: host + '/api/v1/tabularEncuesta',
  tabularEncuestaPROMOPM: host + '/api/v1/tabularEncuestaPROMOPM',
  tabularEncuestaMERCHPM: host + '/api/v1/tabularEncuestaMERCHPM',
  avancePlaza: host + '/api/v1/avancePlaza',
  avanceUsuario: host + '/api/v1/avanceUsuario',
  usuariosGestor: host + '/api/v1/gestor/usuarios',
  dispositivosGestor: host + '/api/v1/gestor/dispositivos',
  autorizarDispositivoGestor: host + '/api/v1/gestor/autorizarDispositivo',
  denegarDispositivoGestor: host + '/api/v1/gestor/denegarDispositivo',
  eliminarDispositivoGestor: host + '/api/v1/gestor/eliminarDispositivo',
}

export default {
  ws: function (method, name, data) {
    if (method === 'get') {
      if (Vue.prototype.$session.exists()) {
        let jwt = Vue.prototype.$session.get('jwt')
        let headers = {
          'Authorization': 'Bearer ' + jwt
        }
        let params = ''
        for (let k in data) {
          params += k + '=' + data[k] + '&'
        }
        params = (params !== '') ? '?' + params : ''
        return axios.get(routes[name] + params, { headers })
          .then(response => {
            let res = response.data
            if (res.correcto) {
              return { ok: true, data: res.data, message: res.mensaje }
            } else {
              return { ok: false, message: res.mensaje }
            }
          })
          .catch(error => {
            console.log(error)
            error.response.status === 403 && router.push('/403')
            return { ok: false, message: 'El servicio no se encuentra disponible en estos momentos' }
          })
      } else {
        router.push('/login')
      }
    }
    else {
      if (Vue.prototype.$session.exists()) {
        let jwt = Vue.prototype.$session.get('jwt')
        let headers = {
          'Authorization': 'Bearer ' + jwt
        }
        return axios.post(routes[name], data, { headers })
          .then(response => {
            let res = response.data
            if (res.correcto) {
              return { ok: true, data: res.data, message: res.mensaje }
            } else {
              return { ok: false, message: res.mensaje }
            }
          })
          .catch(error => {
            console.log(error)
            error.response.status === 403 && router.push('/403')
            return { ok: false, message: 'El servicio no se encuentra disponible en estos momentos' }
          })
      } else {
        router.push('/login')
      }
    }
  },
  routes
}
